import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'sampleResult',
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      lodqRemarksReadOnly: true,
      lodqStatusReadOnly: true,
      cleanQualifiersList: [],
      isColumnVisible: [],
      columnNamesList: [],
      filterColumnsDialog: false,
    }
  },
  computed: {
    qualifiersList() {
      return this.dataObj.appData.qualifiers;
    },
    comparerSymbolsList() {
      //reset list
      let comparerList = [];
      //build new list
      this.dataObj.appData.comparers.forEach(elem => {
        let el = { selected: elem.selected, value: elem.value };
        switch (elem.text) {
          case "Less":
            el['text'] = '<';
            break;
          case "Equal":
            el['text'] = '=';
            break;
          case "More":
            el['text'] = '>';
            break;
          default:
            el['text'] = elem.text;
        }
        comparerList.push(el);
      });
      return comparerList;
    },
  },
  created() {
    this.init();
  },
  watch: {
    isColumnVisible: function (val) {
      this.saveSelectionToCookies(this.isColumnVisible);
    }
  },
  methods: {
    init() {
      if (this.dataObj.appData.sampleResults.length <= 0)
        this.$alertMsg(this.$t('lims.noSamplesResults'),1);

      this.setColumnNamesList();

      //check if selection is in cookies
      var _isColumnVisible = this.$localStorage.get('_isColumnVisible');
      //console.log("get cookies", _isColumnVisible);

      //error trap
      if (_isColumnVisible != 'null' && _isColumnVisible != null) {
        this.isColumnVisible = _isColumnVisible.split(',');
      }

      //values from cookies comes as strings. convert to boolean
      for (var i = 0; i < this.columnNamesList.length; i++) {
        if (this.isColumnVisible[i] == 'true')
          this.isColumnVisible[i] = true;
        else if (this.isColumnVisible[i] != true)
          this.isColumnVisible[i] = false;
      }
    },
    selectAll(bool) {
      //tbi save to cookies
      for (var i = 0; i < this.isColumnVisible.length; i++) {
        this.isColumnVisible[i] = bool;
      }
      this.$forceUpdate();
      //save selection to cookies
      if (bool)
        this.saveSelectionToCookies(this.isColumnVisible);
      else
        this.saveSelectionToCookies(null);
    },
    saveSelectionToCookies(item) {
      this.$localStorage.set('_isColumnVisible', item);
    },
    openFilterDialog() {
      this.filterColumnsDialog = true;
    },
    setColumnNamesList() {
      let colList = [];
      colList.push(this.$t('lims.parameter'));
      colList.push(this.$t('lims.description'));
      colList.push(this.$t('lims.toBeTested'));
      colList.push(this.$t('lims.comparer'));
      colList.push(this.$t('lims.value'));
      colList.push(this.$t('lims.wdValue'));
      colList.push(this.$t('lims.forcedValue'));
      colList.push(this.$t('lims.unit'));
      colList.push(this.$t('lims.standard'));
      colList.push(this.$t('lims.status'));
      colList.push(this.$t('lims.statusQualifier'));
      colList.push(this.$t('lims.riskCategory'));
      colList.push(this.$t('lims.reportingDetectionLimit')); 
      colList.push(this.$t('lims.importedRemarks'));
      colList.push(this.$t('lims.precision'));
      colList.push(this.$t('lims.accuracy'));
      colList.push(this.$t('lims.confidenceLevel'));
      colList.push(this.$t('lims.lod'));
      colList.push(this.$t('lims.loq'));
      colList.push(this.$t('lims.lod/loqEvaluationStatus'));
      colList.push(this.$t('lims.lod/loqEvaluationRemarks'));
      colList.push(this.$t('lims.labStation'));
      colList.push(this.$t('lims.flag1'));
      colList.push(this.$t('lims.flag2'));
      colList.push(this.$t('lims.flag3'));
      colList.push(this.$t('lims.flag4'));
      colList.push(this.$t('lims.flag5'));
      colList.push(this.$t('lims.flag6'));
      colList.push(this.$t('lims.flag7'));
      colList.push(this.$t('lims.flag8'));
      colList.push(this.$t('lims.flag9'));
      colList.push(this.$t('lims.flag10'));
      colList.push(this.$t('lims.externalRef'));
      colList.push(this.$t('lims.additionalRemarks'));

      this.columnNamesList = colList;
    },
    filterQualifiersList(elem) {
      //filter list according to status dropdown selection
      let qualifList = this.dataObj.appData.qualifiers.filter(el => el.statusId == elem.statusId);

      //error trap, wrong selection reset choice
      if (qualifList.findIndex(element => element.value == elem.qualifierId) < 0)
        elem.qualifierId = qualifList[0].value;

      //console.log("trimmed", qualifList);
      return qualifList;
    },
    errorAlert(elemError) {
      if (elemError = "status")
        this.$alertMsg(this.$t('lims.statusErrorNotifier'),3);
    },
    validateAppData() {
      return true;
    },
    prepareParameterForSave() {
      //create booleanvalue array from boolean accepted/rejected
      this.dataObj.appData.sampleResults.forEach(elem => {
        //avoid creating array if both values are empty
        if (elem.isBooleanValue == true) {
          elem.booleanValue = [];
          elem.booleanValue.push({ Description: elem.booleanRejected });
          elem.booleanValue.push({ Description: elem.booleanAccepted });
        }
      });
    },
  }
}

